module.exports = __webpack_public_path__ + "static/media/energy3.9e7198fe.png";